import React from "react";
import { object } from "prop-types";

import { removeHtml } from "../../utils/utils";

import "./caption.m.css";

const Caption = ({ story }) => {
  const heroImage = story?.alternative?.home?.default?.["hero-image"];
  const { "hero-image-attribution": attribution = "", "hero-image-caption": caption = "" } = heroImage || story;

  const clearCaption = removeHtml(caption);
  const clearAttribution = removeHtml(attribution);

  return (
    (clearCaption || clearAttribution) && (
      <div styleName="caption">
        {clearCaption && <span>{clearCaption}</span>}
        {clearAttribution && (
          <span styleName={`${clearAttribution && clearCaption ? "divider" : ""}`}>{clearAttribution}</span>
        )}
      </div>
    )
  );
};

Caption.propTypes = {
  story: object.isRequired,
};

export default Caption;
